import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";
import { AttachmentFragment } from "@outschool/ui-components-classroom";
import { LeaderFragment } from "@outschool/ui-components-website";

import {
  SearchSelectedTeacherHeaderQuery,
  SearchSelectedTeacherHeaderQueryVariables,
} from "../../../shared/generated/graphql";

const searchSelectedTeacherHeaderQuery = gql`
  query SearchSelectedTeacherHeader($uid: ID) {
    publicProfile: publicProfileNew(uid: $uid) {
      uid
      leader {
        ...LeaderFragment
        video {
          ...AttachmentFragment
        }
        reviewCount
        averageActivityStarRating
        educatorTiers
      }
    }
  }
  ${LeaderFragment}
  ${AttachmentFragment}
`;

export default function useSelectedTeacher(userUid: string | null | undefined) {
  const { loading, data } = useQueryWithPreviousData<
    SearchSelectedTeacherHeaderQuery,
    SearchSelectedTeacherHeaderQueryVariables
  >(searchSelectedTeacherHeaderQuery, {
    variables: {
      uid: userUid,
    },
    skip: !userUid,
  });

  // @ts-ignore TS(2531): Object is possibly 'null'.
  return { loading, selectedTeacher: data?.publicProfile.leader };
}
